'use client';

import Link from 'next/link';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import StickyBottomBar from '@/components/StickyBottomBar';
import Icon from '@/components/ui/AppIcon';

const lang = 'it';
const WHATSAPP_URL = 'https://wa.me/393757934676';
const BOOK_URL = '/it/prenota';

export default function EfoilBoardsIT() {
  return (
    <>
      <Header lang={lang} />
      <main style={{ background: '#080F1A', color: '#F0F7FF', fontFamily: 'DM Sans, sans-serif' }}>

        {/* ── SECTION 1: HERO ── */}
        <section
          style={{
            position: 'relative',
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden'
          }}>

          {/* Cinematic background */}
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(135deg, #020810 0%, #0B1F2E 40%, #0D2A3A 70%, #071520 100%)'
            }} />

          {/* Sunrise glow */}
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '120%',
              height: '60%',
              background: 'radial-gradient(ellipse at 50% 100%, rgba(255,160,50,0.18) 0%, rgba(0,212,255,0.10) 40%, transparent 70%)',
              pointerEvents: 'none'
            }} />

          {/* Top glow */}
          <div
            style={{
              position: 'absolute',
              top: '-100px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '800px',
              height: '500px',
              background: 'radial-gradient(ellipse, rgba(0,212,255,0.08) 0%, transparent 70%)',
              pointerEvents: 'none'
            }} />

          {/* Decorative horizontal line */}
          <div
            style={{
              position: 'absolute',
              bottom: '30%',
              left: 0,
              right: 0,
              height: '1px',
              background: 'linear-gradient(90deg, transparent, rgba(0,212,255,0.15), rgba(255,160,50,0.1), transparent)'
            }} />


          <div
            style={{
              position: 'relative',
              zIndex: 2,
              maxWidth: '860px',
              margin: '0 auto',
              padding: '0 clamp(20px, 5vw, 60px)',
              textAlign: 'center'
            }}>

            {/* Badge */}
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                background: 'rgba(0,212,255,0.08)',
                border: '1px solid rgba(0,212,255,0.2)',
                borderRadius: '100px',
                padding: '8px 18px',
                fontSize: '12px',
                fontWeight: 600,
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: '#00D4FF'
              }}>

              <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#00D4FF', display: 'inline-block' }} />
              AEROFOILS e-foil · Lago Maggiore
            </div>

            <h1
              style={{
                fontFamily: 'Fraunces, Georgia, serif',
                fontSize: 'clamp(36px, 6vw, 72px)',
                fontWeight: 700,
                lineHeight: 1.1,
                letterSpacing: '-0.02em',
                marginBottom: '24px',
                color: '#F0F7FF'
              }}>

              Acquista il tuo E&#8209;Foil
            </h1>

            <p
              style={{
                fontSize: 'clamp(16px, 2.5vw, 22px)',
                color: 'rgba(240,247,255,0.7)',
                marginBottom: '20px',
                fontWeight: 300,
                letterSpacing: '0.01em',
                lineHeight: 1.6
              }}>Prova, scegli e acquista il tuo Aerofoils con supporto diretto sul lago.


            </p>

            <p
              style={{
                fontSize: 'clamp(14px, 1.8vw, 18px)',
                color: 'rgba(240,247,255,0.5)',
                marginBottom: '48px',
                lineHeight: 1.8,
                maxWidth: '560px',
                margin: '0 auto 48px'
              }}>

              Non è solo uno sport.<br />
              È un nuovo modo di esplorare il lago, in totale libertà.
            </p>

            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link
                href={BOOK_URL}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  background: 'linear-gradient(135deg, #00D4FF, #0099CC)',
                  color: '#080F1A',
                  fontWeight: 700,
                  fontSize: '15px',
                  padding: '16px 32px',
                  borderRadius: '12px',
                  textDecoration: 'none',
                  letterSpacing: '0.02em',
                  boxShadow: '0 0 40px rgba(0,212,255,0.3)',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                }}>

                <Icon name="CalendarDaysIcon" size={18} variant="solid" />
                Prenota un test ride
              </Link>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  background: 'rgba(240,247,255,0.06)',
                  border: '1px solid rgba(240,247,255,0.15)',
                  color: '#F0F7FF',
                  fontWeight: 600,
                  fontSize: '15px',
                  padding: '16px 32px',
                  borderRadius: '12px',
                  textDecoration: 'none',
                  backdropFilter: 'blur(10px)',
                  transition: 'border-color 0.2s ease'
                }}>

                <Icon name="ChatBubbleLeftRightIcon" size={18} />
                Richiedi informazioni
              </a>
            </div>
          </div>

          {/* Scroll indicator */}
          <div
            style={{
              position: 'absolute',
              bottom: '32px',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '8px',
              color: 'rgba(240,247,255,0.3)',
              fontSize: '11px',
              letterSpacing: '0.1em',
              textTransform: 'uppercase'
            }}>

            <span>Scopri</span>
            <Icon name="ChevronDownIcon" size={16} />
          </div>
        </section>

        {/* ── SECTION 2: A NEW WAY ── */}
        <style>{`
          @keyframes bulletFadeIn {
            from { opacity: 0; transform: translateX(-12px); }
            to { opacity: 1; transform: translateX(0); }
          }
          .perche-bullet {
            animation: bulletFadeIn 0.5s ease forwards;
          }
        `}</style>
        <section
          style={{
            padding: 'clamp(80px, 12vw, 140px) 0',
            background: '#000000',
            overflow: 'hidden'
          }}>

          <div
            style={{
              maxWidth: '1100px',
              margin: '0 auto',
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '0',
              alignItems: 'center'
            }}>

            {/* Left: text */}
            <div style={{ padding: '0 clamp(20px, 5vw, 60px)' }}>
              <div
                style={{
                  width: '40px',
                  height: '2px',
                  background: 'linear-gradient(90deg, #00D4FF, transparent)',
                  marginBottom: '24px'
                }} />

              <h2
                style={{
                  fontFamily: 'Fraunces, Georgia, serif',
                  fontSize: 'clamp(28px, 4vw, 48px)',
                  fontWeight: 700,
                  lineHeight: 1.15,
                  letterSpacing: '-0.02em',
                  marginBottom: '28px',
                  color: '#F0F7FF'
                }}>

                Perchè acquistare da noi
              </h2>

              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '18px' }}>
                {[
                  'Partner ufficiale Aerofoils',
                  "Prova reale sull'acqua prima dell'acquisto",
                  'Consulenza diretta sul modello giusto per te',
                  'Setup completo e configurazione personalizzata',
                  'Supporto locale sul lago',
                  'Assistenza e ricambi diretti',
                  "Il costo del test ride viene scalato dall'acquisto"
                ].map((text, i) => (
                  <li
                    key={i}
                    className="perche-bullet"
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '14px',
                      animationDelay: `${i * 0.08}s`
                    }}>
                    <span
                      style={{
                        flexShrink: 0,
                        width: '24px',
                        height: '24px',
                        borderRadius: '50%',
                        background: 'rgba(0,212,255,0.12)',
                        border: '1px solid rgba(0,212,255,0.3)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#00D4FF',
                        fontSize: '13px',
                        fontWeight: 700,
                        marginTop: '1px'
                      }}>
                      ✔
                    </span>
                    <span
                      style={{
                        fontSize: 'clamp(15px, 1.6vw, 17px)',
                        color: 'rgba(240,247,255,0.82)',
                        lineHeight: 1.6,
                        fontWeight: 400
                      }}>
                      {text}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right: video — no card, no border, no shadow, no padding, blends into black */}
            <div style={{ width: '100%', aspectRatio: '16/9', display: 'block' }}>
              <video
                src="https://res.cloudinary.com/deitr9yxx/video/upload/v1774021537/PERFORMANCEboardProductClipCarinthia_16_9_2-ezgif.com-video-to-gif-converter_gvnlgt.mp4"
                autoPlay
                muted
                loop
                playsInline
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block',
                  border: 'none',
                  outline: 'none',
                  boxShadow: 'none',
                  borderRadius: 0,
                  padding: 0,
                  background: '#000'
                }} />

            </div>
          </div>
        </section>

        {/* ── SECTION 3: LUXURY MOMENTS ── */}
        <section
          style={{
            padding: 'clamp(60px, 10vw, 120px) clamp(20px, 5vw, 60px)',
            background: 'linear-gradient(180deg, transparent 0%, rgba(0,212,255,0.03) 50%, transparent 100%)'
          }}>

          <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
            {/* Section header */}
            <div style={{ textAlign: 'center', marginBottom: '60px' }}>
              <p
                style={{
                  fontSize: '12px',
                  fontWeight: 600,
                  letterSpacing: '0.15em',
                  textTransform: 'uppercase',
                  color: '#00D4FF',
                  marginBottom: '16px',
                  fontWeight: 600
                }}>
                Luxury Moments
              </p>
              <h2
                style={{
                  fontFamily: 'Fraunces, Georgia, serif',
                  fontSize: 'clamp(28px, 4vw, 48px)',
                  fontWeight: 700,
                  letterSpacing: '-0.02em',
                  color: '#F0F7FF',
                  lineHeight: 1.1
                }}>

                Scegli il tuo e-foil
              </h2>
            </div>

            {/* Cards */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: '24px'
              }}>

              {[
              {
                icon: 'SunIcon',
                title: 'Adventure',
                subtitle: 'Stabilità & facilità',
                text: 'Perfetta per iniziare e imparare velocemente. Massima stabilità e controllo.',
                accent: '#FFB347'
              },
              {
                icon: 'TrophyIcon',
                title: 'Performance',
                subtitle: 'Versatile & dinamica',
                text: 'Il miglior equilibrio tra stabilità e performance. Ideale per divertirsi davvero sull\'acqua.',
                accent: '#00D4FF'
              },
              {
                icon: 'UserGroupIcon',
                title: 'Competition',
                subtitle: 'Massime prestazioni',
                text: 'Più reattiva, più veloce, più tecnica. Per chi vuole il massimo dall\'e-foil.',
                accent: '#A78BFA'
              }].
              map((card) =>
              <div
                key={card.title}
                style={{
                  background: 'rgba(240,247,255,0.04)',
                  border: '1px solid rgba(240,247,255,0.08)',
                  borderRadius: '20px',
                  padding: '40px 32px',
                  backdropFilter: 'blur(20px)',
                  position: 'relative',
                  overflow: 'hidden',
                  transition: 'transform 0.3s ease, border-color 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-4px)';
                  (e.currentTarget as HTMLDivElement).style.borderColor = `${card.accent}40`;
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLDivElement).style.transform = 'translateY(0)';
                  (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(240,247,255,0.08)';
                }}>

                  {/* Glow */}
                  <div
                  style={{
                    position: 'absolute',
                    top: '-40px',
                    right: '-40px',
                    width: '120px',
                    height: '120px',
                    borderRadius: '50%',
                    background: `radial-gradient(circle, ${card.accent}15 0%, transparent 70%)`,
                    pointerEvents: 'none'
                  }} />

                  <div
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '12px',
                    background: `${card.accent}15`,
                    border: `1px solid ${card.accent}30`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '24px',
                    color: card.accent
                  }}>

                    <Icon name={card.icon as any} size={22} />
                  </div>
                  <h3
                  style={{
                    fontFamily: 'Fraunces, Georgia, serif',
                    fontSize: 'clamp(18px, 2vw, 22px)',
                    fontWeight: 700,
                    marginBottom: '6px',
                    color: '#F0F7FF',
                    lineHeight: 1.3
                  }}>

                    {card.title}
                  </h3>
                  <p
                  style={{
                    fontSize: '13px',
                    fontWeight: 600,
                    color: card.accent,
                    textTransform: 'uppercase',
                    letterSpacing: '0.06em',
                    marginBottom: '16px'
                  }}>
                    {card.subtitle}
                  </p>
                  <p
                  style={{
                    fontSize: '15px',
                    color: 'rgba(240,247,255,0.55)',
                    lineHeight: 1.8,
                    fontWeight: 300
                  }}>

                    {card.text}
                  </p>
                </div>
              )}
            </div>

            {/* Closing line + CTA */}
            <div
              style={{
                textAlign: 'center',
                marginTop: '48px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '24px'
              }}>
              <p
                style={{
                  fontSize: 'clamp(15px, 2vw, 18px)',
                  color: 'rgba(240,247,255,0.65)',
                  lineHeight: 1.7,
                  fontWeight: 300
                }}>
                Non sei sicuro?<br />
                Provale sull&apos;acqua prima di decidere.
              </p>
              <a
                href="/booking"
                style={{
                  display: 'inline-block',
                  background: 'linear-gradient(135deg, #00D4FF, #0099CC)',
                  color: '#000',
                  fontWeight: 700,
                  fontSize: '15px',
                  letterSpacing: '0.04em',
                  padding: '14px 36px',
                  borderRadius: '50px',
                  textDecoration: 'none',
                  transition: 'opacity 0.2s ease, transform 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLAnchorElement).style.opacity = '0.85';
                  (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLAnchorElement).style.opacity = '1';
                  (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(0)';
                }}>
                Prenota un test ride
              </a>
            </div>
          </div>
        </section>

        {/* ── SECTION 4: THE BOARDS ── */}
        <section
          style={{
            padding: 'clamp(80px, 12vw, 140px) clamp(20px, 5vw, 60px)',
            maxWidth: '1100px',
            margin: '0 auto'
          }}>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '60px',
              alignItems: 'center'
            }}>

            {/* Product image — floating cutout — order 2 on mobile */}
            <div
              style={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '360px',
                order: 2
              }}
              className="board-image-col">

              {/* Ambient glow behind board */}
              <div
                style={{
                  position: 'absolute',
                  width: '70%',
                  height: '50%',
                  background: 'radial-gradient(ellipse, rgba(0,212,255,0.18) 0%, rgba(0,153,204,0.08) 40%, transparent 70%)',
                  filter: 'blur(32px)',
                  pointerEvents: 'none',
                  zIndex: 0
                }} />

              <style>{`
                .board-float {
                  position: relative;
                  z-index: 1;
                  width: 100%;
                  max-width: 480px;
                  filter: drop-shadow(0 24px 48px rgba(0,212,255,0.18)) drop-shadow(0 8px 24px rgba(0,0,0,0.5));
                  transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94), filter 0.6s ease;
                  animation: boardFloat 4s ease-in-out infinite;
                  transform-origin: center center;
                }
                .board-float:hover {
                  filter: drop-shadow(0 32px 64px rgba(0,212,255,0.32)) drop-shadow(0 12px 32px rgba(0,0,0,0.6));
                  animation-play-state: paused;
                  transform: translateY(-10px) scale(1.025) rotate(-1deg);
                }
                @keyframes boardFloat {
                  0%, 100% { transform: translateY(0px) rotate(0deg); }
                  50% { transform: translateY(-12px) rotate(-0.5deg); }
                }
                @media (max-width: 640px) {
                  .board-image-col { order: 2 !important; }
                  .board-text-col { order: 1 !important; }
                }
              `}</style>
              <img
                src="/assets/images/foto_prodotto_senza_sfondo-1773522946553.PNG"
                alt="Audi e-tron e-foil board — full carbon fiber performance board with electric hydrofoil"
                className="board-float" />

            </div>

            {/* Conversion-oriented content — order 1 on mobile */}
            <div style={{ order: 1 }} className="board-text-col">
              <div
                style={{
                  width: '40px',
                  height: '2px',
                  background: 'linear-gradient(90deg, #00D4FF, transparent)',
                  marginBottom: '24px'
                }} />

              <h2
                style={{
                  fontFamily: 'Fraunces, Georgia, serif',
                  fontSize: 'clamp(26px, 3.5vw, 42px)',
                  fontWeight: 700,
                  lineHeight: 1.15,
                  letterSpacing: '-0.02em',
                  marginBottom: '20px',
                  color: '#F0F7FF'
                }}>
                Tecnologia che fa<br />
                <span style={{ color: '#00D4FF' }}>la differenza</span>
              </h2>

              <p
                style={{
                  fontSize: '16px',
                  color: 'rgba(240,247,255,0.7)',
                  lineHeight: 1.8,
                  marginBottom: '36px',
                  fontWeight: 300
                }}>
                Ogni dettaglio è progettato per offrire un&apos;esperienza fluida, silenziosa e potente sull&apos;acqua.<br /><br />
                Non è solo una tavola. È una tecnologia che cambia completamente il modo di vivere il lago.
              </p>

              {/* Benefits list */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '40px' }}>
                {[
                  'Silenzio totale sull\'acqua',
                  'Sensazione di volo stabile e controllata',
                  'Potenza immediata e fluida',
                  'Materiali premium e costruzione avanzata'
                ].map((benefit, idx) =>
                  <div
                    key={idx}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '14px',
                      padding: '14px 18px',
                      background: 'rgba(240,247,255,0.03)',
                      border: '1px solid rgba(240,247,255,0.07)',
                      borderRadius: '12px',
                      transition: 'border-color 0.2s ease, background 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(0,212,255,0.25)';
                      (e.currentTarget as HTMLDivElement).style.background = 'rgba(0,212,255,0.05)';
                    }}
                    onMouseLeave={(e) => {
                      (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(240,247,255,0.07)';
                      (e.currentTarget as HTMLDivElement).style.background = 'rgba(240,247,255,0.03)';
                    }}>
                    <span style={{ color: '#00D4FF', fontSize: '18px', fontWeight: 700, flexShrink: 0 }}>✔</span>
                    <span style={{ fontSize: '15px', color: '#F0F7FF', fontWeight: 400 }}>{benefit}</span>
                  </div>
                )}
              </div>

              {/* Closing line + CTA */}
              <p
                style={{
                  fontSize: '16px',
                  color: 'rgba(240,247,255,0.6)',
                  lineHeight: 1.7,
                  marginBottom: '28px',
                  fontStyle: 'italic'
                }}>
                L&apos;unico modo per capirlo davvero?<br />
                <span style={{ color: '#F0F7FF', fontWeight: 500 }}>Provarlo.</span>
              </p>

              <a
                href="/booking"
                style={{
                  display: 'inline-block',
                  padding: '14px 32px',
                  background: 'linear-gradient(135deg, #00D4FF 0%, #0099CC 100%)',
                  color: '#000',
                  fontWeight: 700,
                  fontSize: '14px',
                  letterSpacing: '0.05em',
                  textTransform: 'uppercase',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  transition: 'opacity 0.2s ease, transform 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLAnchorElement).style.opacity = '0.85';
                  (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLAnchorElement).style.opacity = '1';
                  (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(0)';
                }}>
                Prenota un test ride
              </a>
            </div>
          </div>
        </section>

        {/* ── SECTION 7: FINAL CTA ── */}
        <section
          style={{
            padding: 'clamp(80px, 14vw, 160px) clamp(20px, 5vw, 60px)',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden'
          }}>

          {/* Background glow */}
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'radial-gradient(ellipse at 50% 50%, rgba(0,212,255,0.07) 0%, transparent 65%)',
              pointerEvents: 'none'
            }} />

          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '1px',
              background: 'linear-gradient(90deg, transparent, rgba(0,212,255,0.2), transparent)'
            }} />


          <div style={{ position: 'relative', zIndex: 1, maxWidth: '700px', margin: '0 auto' }}>
            <p
              style={{
                fontSize: '12px',
                fontWeight: 600,
                letterSpacing: '0.15em',
                textTransform: 'uppercase',
                color: '#00D4FF',
                marginBottom: '20px'
              }}>

              Inizia il tuo viaggio
            </p>
            <h2
              style={{
                fontFamily: 'Fraunces, Georgia, serif',
                fontSize: 'clamp(30px, 5vw, 60px)',
                fontWeight: 700,
                letterSpacing: '-0.02em',
                marginBottom: '24px',
                color: '#F0F7FF',
                lineHeight: 1.1
              }}>

              Vuoi scoprire se l'e-foil<br />
              <span style={{ color: '#00D4FF' }}>fa per te?</span>
            </h2>
            <p
              style={{
                fontSize: 'clamp(15px, 1.8vw, 18px)',
                color: 'rgba(240,247,255,0.55)',
                lineHeight: 1.8,
                marginBottom: '48px',
                fontWeight: 300
              }}>

                Prenota una prova privata sul lago e vivi l'esperienza in prima persona.
              </p>

            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link
                href={BOOK_URL}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  background: 'linear-gradient(135deg, #00D4FF, #0099CC)',
                  color: '#080F1A',
                  fontWeight: 700,
                  fontSize: '16px',
                  padding: '18px 40px',
                  borderRadius: '14px',
                  textDecoration: 'none',
                  letterSpacing: '0.02em',
                  boxShadow: '0 0 60px rgba(0,212,255,0.35)'
                }}>

                <Icon name="CalendarDaysIcon" size={20} variant="solid" />
                Prenota test ride
              </Link>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  background: 'rgba(240,247,255,0.05)',
                  border: '1px solid rgba(240,247,255,0.15)',
                  color: '#F0F7FF',
                  fontWeight: 600,
                  fontSize: '16px',
                  padding: '18px 40px',
                  borderRadius: '14px',
                  textDecoration: 'none'
                }}>

                <Icon name="ChatBubbleLeftRightIcon" size={20} />
                Parla con noi
              </a>
            </div>
          </div>
        </section>

      </main>
      <Footer lang={lang} />
      <StickyBottomBar lang={lang} />
    </>
  );

}